import { useTranslation } from 'react-i18next';

export type Stat = {
  id: string;
  value: string;
  label: string;
};

export const useBenefits = () => {
  const { t } = useTranslation();

  const benefitsList = t('home.benefits.list', {
    returnObjects: true,
  }) as string[];

  const data = {
    label: t('home.benefits.label'),
    title: t('home.benefits.title'),
    benefits: Array.isArray(benefitsList) ? benefitsList : [],
    stats: [
      {
        id: 'satisfaction',
        value: t('home.benefits.stats.satisfaction.value'),
        label: t('home.benefits.stats.satisfaction.label'),
      },
      {
        id: 'customers',
        value: t('home.benefits.stats.customers.value'),
        label: t('home.benefits.stats.customers.label'),
      },
      {
        id: 'years',
        value: t('home.benefits.stats.years.value'),
        label: t('home.benefits.stats.years.label'),
      },
    ],
    backgroundImage:
      'https://images.unsplash.com/photo-1714647212104-996bbbb6adca?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3ODE2Njg3MTZ8&ixlib=rb-4.1.0&q=80&w=1080',
  };

  return { data };
};

export type BenefitsProps = ReturnType<typeof useBenefits>;
